import { Component, EventEmitter, Input, OnInit, Output, SimpleChanges, OnDestroy, HostListener } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { NzMessageService } from 'ng-zorro-antd/message';
import { NzUploadFile } from 'ng-zorro-antd/upload';
import { ProductService } from 'src/app/services/product.service';
import { CompatibleVehicle, ProductData } from '../models/product.interface';
import * as moment from 'moment';
import { UserData } from 'src/app/models/userData.model';
import { LoginService } from 'src/app/services/login.service';
import { EcatalogService } from 'src/app/services/ecatalog.service';
import { EcatService } from 'src/app/services/ecat.service';
import { encryptParam } from 'src/app/utils/encrypt'
import { SharedTabDataService } from '../shared-tab-data-service.component';
import { RemarkMap, EcatUtils } from 'src/app/utils/ecat-util';
import { NzModalService } from 'ng-zorro-antd/modal';
import { NzImageService } from 'ng-zorro-antd/image';
import { VideoModalComponent } from 'src/app/pages/official-website/ecat/video/video-modal.component';
import { Router } from '@angular/router';

@Component({
  selector: 'app-part-detail',
  templateUrl: './part-detail.component.html',
  styleUrls: ['./part-detail.component.less']
})
export class PartDetailComponent implements OnInit, OnDestroy {
  @Input() id!: number;
  @Output() goBackView = new EventEmitter<any>();
  @Input() activeTabIndex: number = 0;
  isMobile: boolean = false;
  isLogin: boolean = false;
  userData: UserData | undefined;
  debounceTimer: any = null;
  Math = Math;
  parseFloat = parseFloat;

  RemarkMap: any = RemarkMap;
  productData: any;
  mergedCriteria: any;
  imgUrl: any;
  vehicles: any[] = [];
  modelList: any[] = [];
  partVOList: any[] = [];
  imageList: any[] = [];
  currentImageIndex = 0
  currentIndex: number = 0;
  visibleImages: any[] = [];
  itemWidth: number = 105; //img Width
  pageInfo: any = {};
  partDTO: any = {};
  pageIndex = 1;
  pageSize = 10;
  subscription: any;
  isDetailLoading = false;
  isTableLoading = false;
  isMatchedTableLoading = false;
  packagingNoticeCategoryCodes = new Set(['BR003', 'EO001', 'EO002', 'EO005', 'EO006', 'EO007', 'WP010']);

  disabledDate = (current: Date): boolean => {
    if (this.isAutoPlusSevenNeed()) {
      const targetDate = new Date();
      targetDate.setDate(targetDate.getDate() + 7);
      targetDate.setHours(0, 0, 0, 0);
      return current < targetDate; // disable the date before today
    } else {
      const today = new Date();
      today.setHours(0, 0, 0, 0);
      return current < today; // disable the date before today
    }
  };

  isAutoPlusSevenNeed() {
    const storedCustomer = localStorage.getItem("customer");
    const customerInfo = storedCustomer ? JSON.parse(storedCustomer) : null;
    const salesOrg = this.getOrgCode();
    if (customerInfo !== null && salesOrg === 'CN20-G4-40') {
      return true;
    } else {
      return false;
    }
  }

  getOrgCode(): string {

    const orgs = ["/iam", "/oes"];
    const router = orgs.find(org => window.location.pathname.includes(org));
    const orgMapping = JSON.parse(localStorage.getItem('allOrgRoutes') || '{}');
    const userOrg = JSON.parse(localStorage.getItem('sales_org') || '[]');
    const orgList = orgMapping[`${router}`];
    if (window.location.href.includes("Salesportal/iam/cart/gettoken")) {
      return 'CN20-G1-40';
    }
    if (!orgList || orgList.length === 0) {
      return '';
    }
    if (orgList.includes('CN20-G1-40') && userOrg.includes('CN20-G1-40')) {
      return 'CN20-G1-40';
    }

    const firstMatchingOrg = orgList.find((org: any) => userOrg.includes(org));

    return firstMatchingOrg ? firstMatchingOrg : orgList[0];
  }

  // Modal states
  isErrorReportVisible = false
  isAllVehiclesVisible = false

  // Forms
  errorReportForm!: FormGroup
  vehicleFiltersForm!: FormGroup

  // All vehicles data
  allVehicles: CompatibleVehicle[] = []
  filteredVehicles: any[] = []
  vehiclesLoading = false
  matchedCars: any[] = []
  matchedCarBrands: any[] = []
  matchedCarSeries: any[] = []
  matchedCarModels: any[] = []
  matchedDisplacements: any[] = []
  carIdOptions: any[] = []
  matchedYears: any[] = []
  isFromAllMatchedCars = false;
  isReportErrorVisible = false;
  selectedPartNo = '';
  selectedLevelIds = '';
  selectedVinCode = '';
  imageId = '';
  imageUri = '';

  allBrands: any[] = [];
  allFilteredSeries: any[] = [];
  allFilteredModels: any[] = [];
  allFilteredDisplacements: any[] = [];
  allFilteredYears: any[] = [];
  allFilteredCars: any[] = [];
  selectedBrand: any = {};
  selectedSeries: any = {};
  selectedModel: any = {};
  selectedDisplacement: any[] = [];
  selectedYear: any[] = [];
  selectedBrandId: number | null = null;
  widthConfig = ['100px', '160px', '180px', '80px', '80px', '160px', '100px', '120px']

  // Upload
  fileList: NzUploadFile[] = []
  questionContent = '';

  // Table columns for compatible vehicles
  compatibleVehiclesColumns = [
    { title: "品牌", key: "brand" },
    { title: "车系", key: "series" },
    { title: "车型", key: "model" },
    { title: "排量", key: "displacement" },
    { title: "年款", key: "year" },
    { title: "销售款型", key: "salesData" },
    { title: "发动机号", key: "engineModel" },
    { title: "匹配名称", key: "compatibilityNotes" },
    { title: "备注", key: "remarks" },
  ]

  // All vehicles table columns
  allVehiclesColumns = [
    { title: "品牌", key: "carBrandName" },
    { title: "车系", key: "series" },
    { title: "车型", key: "model" },
    { title: "排量", key: "displacement" },
    { title: "年款", key: "year" },
    { title: "销售款型", key: "salesData" },
    { title: "发动机号", key: "engineModel" },
    { title: "匹配名称", key: "compatibilityNotes" },
    { title: "备注", key: "remarks" },
  ]

  constructor(
    private route: ActivatedRoute,
    private productService: ProductService,
    private fb: FormBuilder,
    private message: NzMessageService,
    public ecatalogService: EcatalogService,
    private ecatService: EcatService,
    private sharedData: SharedTabDataService,
    private router: Router,
    private modal: NzModalService,
    private nzImageService: NzImageService
  ) {
    this.initForms()
  }

  ngOnInit(): void {
    this.checkScreenSize();
    // 优先从路由参数获取 partId，兜底使用 @Input() id
    const routePartId = this.route.snapshot.paramMap.get('partId');
    if (routePartId) {
      this.id = Number(routePartId);
    }
    // 从路由 state 中读取 activeTabIndex（通过路由导航进入时使用）
    const navState = history.state;
    if (navState && navState.activeTabIndex !== undefined) {
      this.activeTabIndex = navState.activeTabIndex;
    } else if (routePartId) {
      // 直接通过 URL 访问时，没有共享数据，默认走产品搜索分支（不依赖 SharedTabDataService）
      this.activeTabIndex = 1;
    }
    // this.getArticleDetails();
    this.getMatchedCars();
  }

  @HostListener('window:resize', ['$event'])
  onResize(event: any) {
    this.checkScreenSize();
  }

  checkScreenSize(): void {
    this.isMobile = window.innerWidth < 768;
  }

  getImageDescription(): string {
    const categoryCode = this.productData?.categoryCode;
    if (categoryCode && this.packagingNoticeCategoryCodes.has(categoryCode)) {
      return '图片仅供参考，当前市场上同时存在新老包装产品，以实物为准';
    }
    return '图片仅供参考，以实物为准';
  }

  // getArticleDetails() {
  //   let params = { query: this.id };
  //   this.ecatalogService.queryArticleDetail(params).subscribe((result: any) => {
  //     let data = result.rtnData.articles;
  //     if (data.length > 0) {
  //       this.productData = data[0];
  //       this.productData.quantity = this.productData.minumQty === 0 ? 1 : this.productData.minumQty;
  //       this.productData.expectedDate = this.ensureSevenDaysBuffer();
  //       // this.queryArticleLinkedManufacturer2(this.productData.genericArticles[0].legacyArticleId);
  //       const mfrNameMap: { [key: string]: any[] } = {};
  //       this.productData.oemNumbers?.forEach((item: any) => {
  //         if (!mfrNameMap[item.mfrName]) {
  //           mfrNameMap[item.mfrName] = [];
  //         }
  //         mfrNameMap[item.mfrName].push(item);
  //       });
  //       this.mergedCriteria = this.productData.articleCriteria.reduce((acc: any, curr: any) => {
  //         const existingCriteria = acc.find((item: any) => item.criteriaAbbrDescription === curr.criteriaAbbrDescription);
  //         if (existingCriteria) {
  //           existingCriteria.formattedValue += `, ${curr.formattedValue}`;
  //         } else {
  //           if (curr.criteriaAbbrDescription) {
  //             acc.push(curr);
  //           }
  //         }
  //         return acc;
  //       }, []);
  //     }
  //   });
  // }

  ngOnDestroy(): void {
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
  }

  ensureSevenDaysBuffer() {
    const today = new Date();
    today.setHours(0, 0, 0, 0);
    const minDate = new Date(today);
    minDate.setDate(today.getDate() + 7);
    if (this.isAutoPlusSevenNeed()) {
      return minDate;
    }
    return today;
  }

  openVideoModal(categoryName: string, remark: string): void {
    let videoUrl = RemarkMap[categoryName as keyof typeof RemarkMap]?.[remark as keyof typeof RemarkMap[keyof typeof RemarkMap]];
    this.modal.create({
      nzTitle: '视频播放',
      nzContent: VideoModalComponent,
      nzComponentParams: {
        videoUrl: videoUrl
      },
      nzFooter: null,
      nzWidth: 800
    });
  }

  getRemarks(remark: string, categoryName: string) {
    return EcatUtils.mapRemark(remark, categoryName);
  }

  isVideoModal(remark: any) {
    const nonVideoList = ['AP1', 'AP3', 'AP4', 'AP6', '2AA', '2BB', '2CC', '1A', '1B', '2A', '2C'];
    if (nonVideoList.includes(remark)) {
      return true;
    } else {
      return false;
    }
  }

  hasVideoUrl(categoryName: string, remark: string) {
    return RemarkMap[categoryName as keyof typeof RemarkMap]?.[remark as keyof typeof RemarkMap[keyof typeof RemarkMap]];
  }

  processData(partDTO: any) {
    if (partDTO !== null && partDTO !== undefined) {
      let rainWiperLengths = []
      let displayFeature
      let display1Feature
      let display2Feature
      const rainWiper1Feature = partDTO.partFeatureValueList && partDTO.partFeatureValueList.find((feature: any) => feature.featureNameCn === '长度 1（英寸）')
      const rainWiper2Feature = partDTO.partFeatureValueList && partDTO.partFeatureValueList.find((feature: any) => feature.featureNameCn === '长度 2（英寸）')
      if (rainWiper1Feature || rainWiper2Feature) {
        displayFeature = partDTO.partFeatureValueList.filter((feature: any) => feature.featureNameCn !== '雨刮1长度' && feature.featureNameCn !== '雨刮2长度(仅套装)' && feature.featureNameCn !== '长度 1' && feature.featureNameCn !== '长度 2')
        rainWiperLengths = displayFeature
      }
      else {
        const rainWiper3Feature = partDTO.partFeatureValueList && partDTO.partFeatureValueList.find((feature: any) => feature.featureNameCn === '雨刮1长度')
        const rainWiper4Feature = partDTO.partFeatureValueList && partDTO.partFeatureValueList.find((feature: any) => feature.featureNameCn === '雨刮2长度(仅套装)')
        if (rainWiper3Feature || rainWiper4Feature) {
          display1Feature = partDTO.partFeatureValueList.filter((feature: any) => feature.featureNameCn !== '长度 1' && feature.featureNameCn !== '长度 2')
          rainWiperLengths = display1Feature
        } else {
          display2Feature = partDTO.partFeatureValueList
          rainWiperLengths = display2Feature
        }
      }
      const isEmpty = (v: any) => v === null || v === undefined || v === '';
      return rainWiperLengths.filter((f: any) => !(isEmpty(f.featureValueString) && isEmpty(f.featureValue)) && f.featureNameCn !== '中心电极材料');
    } else {
      return [];
    }
  };

  editFeatureNameCn(featureNameCn: any) {
    if (!featureNameCn) {
      return
    }
    const item = this.partVOList[0];

    if (item) {
      const isAllSize1 = item.partDTO.partFeatureValueList?.find((feature: any) => feature.featureNameCn === '雨刮1长度') && item.partDTO.partFeatureValueList?.find((feature: any) => feature.featureNameCn === '雨刮2长度(仅套装)')
      const isAllSize2 = item.partDTO.partFeatureValueList?.find((feature: any) => feature.featureNameCn === '长度 1') && item.partDTO.partFeatureValueList?.find((feature: any) => feature.featureNameCn === '长度 2')
      const isAllSize3 = item.partDTO.partFeatureValueList?.find((feature: any) => feature.featureNameCn === '长度 1（英寸）') && item.partDTO.partFeatureValueList?.find((feature: any) => feature.featureNameCn === '长度 2（英寸）')
      const isOnlySize1 = item.partDTO.partFeatureValueList?.find((feature: any) => feature.featureNameCn === '雨刮1长度')
      const isOnlySize2 = item.partDTO.partFeatureValueList?.find((feature: any) => feature.featureNameCn === '长度 1')
      const isOnlySize3 = item.partDTO.partFeatureValueList?.find((feature: any) => feature.featureNameCn === '长度 1（英寸）')
      if (isAllSize3) {
        if (featureNameCn === '长度 1（英寸）' || featureNameCn === '长度 1' || featureNameCn === '雨刮1长度') {
          return '主驾尺寸(英寸)'
        } else if (featureNameCn === '长度 2（英寸）' || featureNameCn === '长度 2' || featureNameCn === '雨刮2长度(仅套装)') {
          return '副驾尺寸(英寸)'
        }
      } else if (isAllSize1) {
        if (isOnlySize3) {
          return '尺寸(英寸)'
        } else {
          if (featureNameCn === '长度 1（英寸）' || featureNameCn === '长度 1' || featureNameCn === '雨刮1长度') {
            return '主驾尺寸(英寸)'
          } else if (featureNameCn === '长度 2（英寸）' || featureNameCn === '长度 2' || featureNameCn === '雨刮2长度(仅套装)') {
            return '副驾尺寸(英寸)'
          }
        }
      } else if (isAllSize2) {
        if (isOnlySize3 || isOnlySize1) {
          return '尺寸(英寸)'
        } else {
          if (featureNameCn === '长度 1（英寸）' || featureNameCn === '长度 1' || featureNameCn === '雨刮1长度') {
            return '主驾尺寸(英寸)'
          } else if (featureNameCn === '长度 2（英寸）' || featureNameCn === '长度 2' || featureNameCn === '雨刮2长度(仅套装)') {
            return '副驾尺寸(英寸)'
          }
        }
      } else if (isOnlySize3) {
        return '尺寸(英寸)'
      } else if (isOnlySize1) {
        if (!isAllSize3) {
          return '尺寸(英寸)'
        } else {
          if (featureNameCn === '长度 1（英寸）' || featureNameCn === '长度 1' || featureNameCn === '雨刮1长度') {
            return '主驾尺寸(英寸)'
          } else if (featureNameCn === '长度 2（英寸）' || featureNameCn === '长度 2' || featureNameCn === '雨刮2长度(仅套装)') {
            return '副驾尺寸(英寸)'
          }
        }
      } else if (isOnlySize2) {
        if (!isAllSize3 || !isAllSize1) {
          return '尺寸(英寸)'
        } else {
          if (featureNameCn === '长度 1（英寸）' || featureNameCn === '长度 1' || featureNameCn === '雨刮1长度') {
            return '主驾尺寸(英寸)'
          } else if (featureNameCn === '长度 2（英寸）' || featureNameCn === '长度 2' || featureNameCn === '雨刮2长度(仅套装)') {
            return '副驾尺寸(英寸)'
          }
        }
      }
    }
    return featureNameCn;
  };

  // queryArticleLinkedManufacturer2(legacyArticleId: string) {
  //   let params = { articleId: legacyArticleId };
  //   this.ecatalogService.queryArticleLinkedManufacturer2(params).subscribe((result: any) => {
  //     this.vehicles = result.rtnData;
  //   });
  // }
  updateVisibleImages() {
    this.visibleImages = this.imageList.slice(this.currentIndex, this.currentIndex + 5) as any[];
  }
  scrollLeft() {
    if (this.currentIndex > 0) {
      this.currentIndex--;
      this.updateVisibleImages();
    }
  }

  scrollRight() {
    if (this.currentIndex < this.imageList.length - 5) {
      this.currentIndex++;
      this.updateVisibleImages();
    }
  }
  getFormattedModelLabel(model: any): string {
    if (model && model.name) {
      return `${model.manufacturer} - ${model.name} `
    }
    return '';
  }
  selectImage(index: number): void {
    if (this.imageList.length > 0 && index >= 0 && index < this.imageList.length) {
      this.currentImageIndex = index
    }
  }

  getSingleImage(image: any) {
    if (image !== '') {
      return 'https://spiderbeast2.blob.core.chinacloudapi.cn/pim-attachment/' + image.imageName;
    } else {
      return 'assets/official-website/no-image.png'
    }
  }

  getImage(imageList: any) {
    if (imageList.length > 0) {
      return 'https://spiderbeast2.blob.core.chinacloudapi.cn/pim-attachment/' + imageList[this.currentImageIndex].imageName;
    } else {
      return 'assets/official-website/no-image.png'
    }
  }

  // 点击主图时放大预览：预览列表与缩略图区（nz-image-group）保持一致，
  // 并从当前 currentImageIndex 对应的那张图开始，支持左右切换浏览。
  previewCurrentImage(): void {
    if (!this.imageList || this.imageList.length === 0) {
      return;
    }
    const images = this.imageList.map(item => ({ src: this.getSingleImage(item) }));
    const previewRef = this.nzImageService.preview(images);
    const index = Math.min(Math.max(this.currentImageIndex, 0), images.length - 1);
    previewRef.switchTo(index);
  }

  goBack(): void {
    const routePartId = this.route.snapshot.paramMap.get('partId');
    if (routePartId) {
      window.history.back();
    } else {
      this.goBackView.emit();
    }
  }

  // ngOnChanges(changes: SimpleChanges) {
  //   if (changes['id'] && changes['id'].currentValue) {
  //     this.getArticleDetails();
  //   }
  // }


  onPageSizeChange(size: number): void {
    this.pageSize = size;
    this.handleSearchCars();
  }

  onPageIndexChange(pageIndex: number): void {
    this.pageIndex = pageIndex;
    this.handleSearchCars();
  }

  getMatchedCars() {
    this.isDetailLoading = true;
    if (this.activeTabIndex === 0) {
      this.subscription = this.sharedData.currentTabData.subscribe(data => {
        const isAllChecked = data.otherData.allChecked;
        const selectedVeh = data.otherData.selectedVeh;
        const selectedLevelIds = data.otherData.selectedLevelIds;
        const selectedVinCode = data.otherData.selectedVinCode;
        this.selectedLevelIds = selectedLevelIds;
        this.selectedVinCode = selectedVinCode;
        let carIds = '';
        const carIdsArr: any[] = [];
        selectedVeh.forEach((item: any) => {
          carIds = carIds + "," + item.carId;
          carIdsArr.push(item.carId);
        });
        this.carIdOptions = carIdsArr;
        this.ecatService.partCarQuery({
          carIds: carIds,
          levelIds: selectedLevelIds,
          partIds: this.id.toString(),
          languageType: 'zh-cn'
        })
          .subscribe(result => {

            this.isDetailLoading = false;
            const { resultCode, resultData, resultMsg } = result;
            const partVOList = resultData.partVOList
            partVOList.forEach((item: any) => {
              item?.partDTO?.partFeatureValueList?.forEach((feature: any) => {
                if (item?.partDTO?.category1Name?.includes('雨刮') &&
                  (feature.featureNameCn === '雨刮1长度' ||
                  feature.featureNameCn === '雨刮2长度(仅套装)' ||
                  feature.featureNameCn === '长度 1' ||
                  feature.featureNameCn === '长度 2')
                ) {
                  const regex = /(\d+(\.\d+)?)/
                  const match = feature.featureValue.match(regex)
                  if (match) {
                    const number = parseFloat(match[0])
                    console.log(number)
                    const roundedNumber = number / 25.4
                    console.log('roundedNumber', roundedNumber)
                    // const unit = feature.featureValue.replace(match[0], '')
                    feature.featureValue = `${roundedNumber}`
                    console.log(feature.featureValue)
                  }
                }
              })
            })
            this.partVOList = partVOList
            if (resultData.partVOList) {
              const partDto = resultData.partVOList[0].partDTO || []
              this.productData = partDto;
              this.selectedPartNo = partDto?.partNo;
              const content = '料号【' + partDto?.partNo + '】存在配件匹配错误';
              this.questionContent = content;
              this.errorReportForm.controls['content'].setValue(content);
              this.imageList = resultData.partVOList[0].partDTO.imageList || []
            }
            this.isReportErrorVisible = true;
            if (isAllChecked) {
              // this.matchedCars = [];
              this.isFromAllMatchedCars = true;
              const passedBrandId = data.otherData.queryParams.brandId;
              this.handleSearchMatchedCars(passedBrandId);
            } else {
              this.errorReportForm.controls['carIds'].setValue(carIdsArr);
              this.matchedCars = resultData.partVOList[0].carDetailList;
            }
          });
      })
    } else {
      this.ecatService.partCarQuery({
        partIds: this.id.toString(),
        languageType: 'zh-cn'
      })
        .subscribe(result => {

          this.isDetailLoading = false;
          const { resultCode, resultData, resultMsg } = result; const partVOList = resultData.partVOList
          partVOList.forEach((item: any) => {
            item?.partDTO?.partFeatureValueList?.forEach((feature: any) => {
              if (item?.partDTO?.category1Name?.includes('雨刮') &&
                (feature.featureNameCn === '雨刮1长度' ||
                feature.featureNameCn === '雨刮2长度(仅套装)' ||
                feature.featureNameCn === '长度 1' ||
                feature.featureNameCn === '长度 2')
              ) {
                const regex = /(\d+(\.\d+)?)/
                const match = feature.featureValue.match(regex)
                if (match) {
                  const number = parseFloat(match[0])
                  console.log(number)
                  const roundedNumber = number / 25.4
                  console.log('roundedNumber', roundedNumber)
                  // const unit = feature.featureValue.replace(match[0], '')
                  feature.featureValue = `${roundedNumber}`
                  console.log(feature.featureValue)
                }
              }
            })
          })
          this.partVOList = partVOList
          if (resultData.partVOList) {
            const partDto = resultData.partVOList[0].partDTO || [];
            this.productData = partDto;
            this.selectedPartNo = partDto?.partNo;
            this.errorReportForm.controls['content'].setValue('料号【' + partDto?.partNo + '】存在配件匹配错误');
            this.imageList = resultData.partVOList[0].partDTO.imageList || []
          }
        });
      // this.matchedCars = [];
      this.isFromAllMatchedCars = true;
      this.handleSearchMatchedCars('');
    }
  }

  getMatchedBrands() {
    this.ecatService.getBrand({
      partId: this.id,
      languageType: 'zh-cn'
    })
      .subscribe(result => {
        const { resultCode, resultData, resultMsg } = result;
        this.allBrands = resultData.carBrand;
      });
  }
  onSelectBrandChange(selectedBrand: any) {
    this.selectedSeries = {};
    this.selectedModel = {};
    this.selectedDisplacement = [];
    this.selectedYear = [];
    this.allFilteredSeries = [];
    this.allFilteredModels = [];
    this.allFilteredDisplacements = [];
    this.allFilteredYears = [];
    if (selectedBrand === null) {
      return;
    }
    this.getSeriesList(selectedBrand.brandId);
  }

  getSeriesList(item: any) {
    this.ecatService.seriesList({ brandId: item, languageType: 'zh-cn', partId: this.id }).subscribe(result => {
      const { resultCode, resultData } = result;
      this.allFilteredSeries = resultData.carSeriesList;
    });
  }

  onSelectSeriesChange(item: any) {
    this.selectedModel = {};
    this.selectedDisplacement = [];
    this.selectedYear = [];
    this.allFilteredModels = [];
    this.allFilteredDisplacements = [];
    this.allFilteredYears = [];
    if (item === null) {
      return;
    }
    const encodedManufacture = encodeURIComponent(item.manufacturer);
    const data = {
      brandId: this.selectedBrand.brandId,
      manufacturer: encodedManufacture,
      modelClass: item.modelClass,
      partId: this.id,
      languageType: 'zh-cn',
    }
    console.log('data', data)
    this.ecatService.modelList(data).subscribe(result => {
      const { resultCode, resultData } = result;
      this.allFilteredModels = resultData.carModelList;
      this.allFilteredDisplacements = resultData.displacementList;
      this.allFilteredYears = resultData.modelYearList;
      console.log('resultData', resultData)
    });
  }

  onSelectModelChange(item: any) {
    this.selectedDisplacement = [];
    this.selectedYear = [];
    this.allFilteredDisplacements = [];
    this.allFilteredYears = [];
    if (item === null) {
      return;
    }
    this.ecatService.displacementList({ brandId: this.selectedBrand.brandId, modelId: item.modelId, partId: this.id, languageType: 'zh-cn' }).subscribe(result => {
      const { resultCode, resultData } = result;
      this.allFilteredDisplacements = resultData.displacementList;
    });
  }

  onSelectDisplacementChange(item: any) {
    this.selectedYear = [];
    this.allFilteredYears = [];
    if (item === null) {
      return;
    }
    const selectedSeries = this.selectedSeries;
    const encodedManufacture = encodeURIComponent(selectedSeries.manufacturer);
    const modelClass = selectedSeries.modelClass + ',' + encodedManufacture
    const params = {
      brandId: this.selectedBrand.brandId, modelId: this.selectedModel.modelId, modelClass: modelClass,
      displacement: item, modelYear: '', partId: this.id, languageType: 'zh-cn'
    }
    this.ecatService.modelyearList(params).subscribe(result => {
      const { resultCode, resultData } = result;
      this.allFilteredYears = resultData.modelYearList;
    });
  }

  handleSearchMatchedCars(brandId: string) {
    this.isMatchedTableLoading = true;
    const params = {
      page: this.pageIndex,
      pageSize: this.pageSize,
      partId: encryptParam(this.id.toString()),
      brandId: encryptParam(brandId ? brandId : ''),
      languageType: encryptParam('zh-cn')
    }
    this.ecatService.carQuery(params).subscribe(result => {
      this.isMatchedTableLoading = false;
      const { resultCode, resultData } = result;
      this.matchedCars = resultData.carInfoList;
    });
  }

  handleSearchCars() {
    this.isTableLoading = true;
    const selectedSeries = this.selectedSeries;
    let encodedManufacture = '';
    let modelClass = '';
    if (Object.keys(selectedSeries).length !== 0) {
      encodedManufacture = encodeURIComponent(selectedSeries.manufacturer);
      modelClass = selectedSeries.modelClass
    }
    const params = {
      page: this.pageIndex,
      pageSize: this.pageSize,
      partId: encryptParam(this.id.toString()),
      brandId: encryptParam(this.selectedBrand.brandId ? this.selectedBrand.brandId : ''),
      manufacturer: encryptParam(encodedManufacture ? encodedManufacture : ''),
      modelClass: encryptParam(modelClass ? modelClass : ''),
      modelId: encryptParam(this.selectedModel.modelId ? this.selectedModel.modelId : ''),
      displacement: encryptParam(this.selectedDisplacement.toString()),
      modelYear: encryptParam(this.selectedYear.toString()),
      languageType: encryptParam('zh-cn')
    }
    this.ecatService.carQuery(params).subscribe(result => {
      this.isTableLoading = false;
      const { resultCode, resultData } = result;
      this.filteredVehicles = resultData.carInfoList;
      this.pageInfo = resultData.pageInfo;
    });
  }

  handleReloadFilter() {
    this.selectedBrand = {};
    this.selectedSeries = {};
    this.selectedModel = {};
    this.selectedDisplacement = [];
    this.selectedYear = [];
    this.allFilteredSeries = [];
    this.allFilteredModels = [];
    this.allFilteredDisplacements = [];
    this.allFilteredYears = [];
    this.filteredVehicles = [];
    this.handleSearchCars();
  }

  private initForms(): void {
    this.fileList = [];
    this.errorReportForm = this.fb.group({
      contactInfo: ["", [Validators.required]],
      subjectType: ["01", [Validators.required]],
      content: ["", [Validators.required, Validators.maxLength(500)]],
      agreeToPolicy: [false, [Validators.requiredTrue]],
      carIds: [[]],
      remark: ["", [Validators.maxLength(500)]],
    })

    this.vehicleFiltersForm = this.fb.group({
      brand: [""],
      series: [""],
      model: [""],
      displacement: [""],
      year: [""],
    })
  }

  resetForms(): void {
    this.fileList = [];
    this.errorReportForm.patchValue({
      contactInfo: "",
      remark: "",
      agreeToPolicy: false,
      content: this.questionContent
    })
  }

  // Error report modal
  showErrorReportModal(): void {
    this.isErrorReportVisible = true
  }

  handleErrorReportCancel(): void {
    this.isErrorReportVisible = false
    this.resetForms()
  }

  handleErrorReportSubmit(): void {
    if (!this.errorReportForm.get('agreeToPolicy')?.value) {
      this.message.create('warning', '请阅读并同意相关的隐私条款');
    }
    if (this.errorReportForm.valid) {
      const formValue = this.errorReportForm.value;
      const partId = this.id.toString();
      const partNo = this.selectedPartNo;
      const params = {
        ...formValue,
        partId,
        partNo,
        languageType: "zh-cn",
        levelIds: this.selectedLevelIds,
        vinCode: this.selectedVinCode,
        imageId: this.imageId,
        imageUri: this.imageUri,
      };
      this.ecatService.submitErrorReport(params).subscribe({
        next: () => {
          this.message.success("报错信息提交成功")
          this.isErrorReportVisible = false
          this.resetForms()
        },
        error: () => {
          this.message.error("提交失败，请重试")
        },
      })
    } else {
      Object.values(this.errorReportForm.controls).forEach((control: any) => {
        if (control.invalid) {
          control.markAsDirty()
          control.updateValueAndValidity({ onlySelf: true })
        }
      })
    }
  }

  // All vehicles modal
  showAllVehiclesModal(): void {
    this.isAllVehiclesVisible = true
    // this.loadAllVehicles()
    this.getMatchedBrands()
    this.handleSearchCars();
  }

  handleAllVehiclesCancel(): void {
    this.isAllVehiclesVisible = false
    this.vehicleFiltersForm.reset()
  }

  private loadAllVehicles(): void {
    if (!this.productData) return

    this.vehiclesLoading = true
    this.productService.getAllCompatibleVehicles(this.productData.code).subscribe({
      next: (vehicles) => {
        this.allVehicles = vehicles
        this.filteredVehicles = vehicles
        this.vehiclesLoading = false
      },
      error: () => {
        this.message.error("车型数据加载失败")
        this.vehiclesLoading = false
      },
    })
  }

  handleViewPrivacy(url: string, index?: number) {
    const country = localStorage.getItem("country");
    this.router.navigate([`${country ? country : '/iam'}${url}`], { queryParams: { index: index } });
  }

  resetVehicleFilters(): void {
    this.vehicleFiltersForm.reset()
    this.filteredVehicles = this.allVehicles
  }

  searchVehicles(): void {
    const filters = this.vehicleFiltersForm.value
    this.filteredVehicles = this.allVehicles.filter((vehicle) => {
      return (
        (!filters.brand || vehicle.brand.includes(filters.brand)) &&
        (!filters.series || vehicle.series.includes(filters.series)) &&
        (!filters.model || vehicle.model.includes(filters.model)) &&
        (!filters.displacement || vehicle.displacement.includes(filters.displacement)) &&
        (!filters.year || vehicle.year.includes(filters.year))
      )
    })
  }

  // Upload handlers
  beforeUpload = (file: NzUploadFile): boolean => {
    const formData = new FormData();
    formData.append('file', file as any);
    this.ecatService.uploadFile(formData).subscribe(result => {
      const { resultCode, resultData, success, resultMsg } = result;
      if (success) {
        this.imageId = resultData.fileDTO.fileId;
        this.imageUri = resultData.fileDTO.fileUri;
        this.fileList = [file];
      } else {
        this.message.create('warning', resultMsg);
      }
      console.log('resultData', resultData)
    });
    return false
  }

  removeFile = (file: NzUploadFile): boolean => {
    this.fileList = this.fileList.filter((f) => f !== file)
    return true
  }

  // Copy product code
  copyProductCode(): void {
    if (this.productData) {
      navigator.clipboard.writeText(this.productData?.partNo).then(() => {
        this.message.success("产品代码已复制")
      })
    }
  }

  // Copy product code
  copyPartCode(partNo: any): void {
    const textToCopy = partNo.map((item: any) => item.partNo).join(' ');
    navigator.clipboard.writeText(textToCopy).then(() => {
      this.message.success("产品代码已复制")
    })
  }


  minusQuantity(product: any): void {
    if (product.minumQty === 0) {
      product.minumQty = 1;
    }
    if (product.minumQty && product.quantity > product.minumQty) {
      product.quantity = product.quantity - product.minumQty;
    }
  }
  chooseDate(product: any): void {
    const oneWeekLater = moment().add(7, 'days');
    product.expectedDate = oneWeekLater.format('YYYY-MM-DD');
  }

  addQuantity(product: any): void {
    if (product.minumQty === 0) {
      product.minumQty = 1;
    }
    if (product.minumQty && product.quantity) {
      product.quantity = product.quantity + product.minumQty;
    }
  }

  quantityBlur(newQuantity: number) {
    this.productData!.quantity = newQuantity;
  }
  quantityChange(newQuantity: number) {
    if (this.debounceTimer) {
      clearTimeout(this.debounceTimer);
    }
    this.debounceTimer = setTimeout(() => {
      this.productData!.quantity = newQuantity;
    }, 1000);
  }

  brandFilterOption = (input: string, option: any): boolean => {
    const keyword = input.toLowerCase();
    return (
      // 中文或英文名字包含输入
      option.nzLabel.toLowerCase().includes(keyword) ||
      // 拼音首字母包含输入
      option.nzValue.brandNamePY.toLowerCase().includes(keyword)
    );
  };

  seriesFilterOption = (input: string, option: any): boolean => {
    const keyword = input.toLowerCase();
    return (
      // 中文或英文名字包含输入
      option.nzLabel.toLowerCase().includes(keyword) ||
      // 拼音首字母包含输入
      option.nzValue.modelClassPY.toLowerCase().includes(keyword)
    );
  };

  modelFilterOption = (input: string, option: any): boolean => {
    const keyword = input.toLowerCase();
    return (
      // 中文或英文名字包含输入
      option.nzLabel.toLowerCase().includes(keyword) ||
      // 拼音首字母包含输入
      option.nzValue.modelNamePY.toLowerCase().includes(keyword)
    );
  };
}
